<template>
  <div class="yimiao">
    <div>
      <div style="
          border-bottom: 1px solid #e6e6e6;
          padding: 10px 15px;
          position: relative;
        ">
        <div style="display: inline-block; width: 60px">
          <img style="width: 100%"
            src="../../../assets/返淇.png"
            alt="" />
        </div>
        <div style="
            display: inline-block;
            position: absolute;
            top: 30px;
            left: 100px;
          ">
          <div style="font-size: 18px">返(来)洛人员报备</div>
        </div>
      </div>
      <div>
        <van-cell-group>
          <van-cell-group>
            <van-field v-model="datafrom.idCard"
              label="身份证号"
              required
              placeholder="请输入身份证号码" />
          </van-cell-group>
          <van-field v-model="datafrom.name"
            label=" 姓 名 "
            required
            placeholder="请输入姓名" />
        </van-cell-group>

        <!-- 全部 -->
        <div class="center"
          v-for="item in list"
          :key="item.index"
          @click="add(item.HId)"
          style="
            border: 1px solid rgb(222 206 206);
            width: 95%;
            margin: 5px auto;
            border-radius: 5px;
          ">
          <div class="Content"
            style="padding: 8px 10px">
            <div style="display: inline-block">
              <span class="centertime"
                style="color: #333; font-size: 17px">
                姓名：{{ item.Name }}
              </span>
              <div style="font-size: 17px; color: #333; margin: 5px 0">
                身份证号：{{ item.IdNumber }}
              </div>
              <div style="font-size: 17px; color: #333; margin: 5px 0">
                {{ item.OrganName }}-{{ item.RName }}-{{ item.Room }}
              </div>
            </div>
          </div>
        </div>
        <div class="buttons"
          style="position: fixed; bottom: 0px; width: 100%">
          <van-button type="info"
            style="margin: 10px 0"
            @click="postfrom()">下一步</van-button>
          <van-button style="border: 1px solid #e6e6e6; margin: 10px 0"
            type="
          default"
            @click="fanhui()">返回</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Dialog } from "vant";
import { Toast } from "vant";
import { setOpenId, getOpenId } from "@/utils/auth";
import config from "@/config";
import Compressor from "compressorjs";
import axios from "axios";
Vue.use(Toast);
import { WxSearchResident } from "@/api/yeguang";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data () {
    return {
      datafrom: {
        name: "",
        idCard: "",
      },
      list: [],
    };
  },
  created () { },
  methods: {
    postfrom: function () {
      if (this.datafrom.idCard == "") {
        Toast.fail("请输入身份证号");
        return false;
      }
      if (this.datafrom.name == "") {
        Toast.fail("请输入姓名");
        return false;
      }

      console.log(this.datafrom);
      this.datafrom.OpenID = getOpenId();
      WxSearchResident(this.datafrom).then((res) => {
        if (res.data.code == 0) {
          this.list = res.data.data;
          if (this.list.length == "1") {
            // Toast.fail("查询成功");
            // console.log(this.list[0].HId);
            this.$router.push({
              path: "/register/fangyi/fanqiNew/fqShouye/fqYou/" + this.list[0].HId,
            });
          } else if (this.list.length > "1") {
            Dialog.alert({
              title: "提示",
              message: "操作成功，请选择需要报备的人员信息",
            }).then(() => {
              // this.$router.go(-1);
              // this.$router.push({
              //   name: "register",
              // });
            });
          } else {
            Dialog.confirm({
              title: "提示",
              message: "没有找到人员信息，可点击确定进行返洛人员报备",
            })
              .then(() => {
                console.log(this.datafrom);
                if (this.datafrom.idCard == '') {
                  this.$router.push({
                    path: "/register/fangyi/fanqiNew/fqShouye/fqWu/" + this.datafrom.name + '/' + undefined,
                  });
                } else {
                  this.$router.push({
                    path: "/register/fangyi/fanqiNew/fqShouye/fqWu/" + this.datafrom.name + '/' + this.datafrom.idCard,
                  });
                }

              })
              .catch(() => {
              });
          }
        } else {
          Dialog.alert({
            title: "提示",
            message: "提交失败!" + res.data.msg,
          }).then(() => {
            // on close
          });
        }
      });
    },

    add (hid) {
      this.$router.push({
        path: "/register/fangyi/fanqiNew/fqShouye/fqYou/" + hid,
        // query: { hid: hid },
      });
    },
    fanhui: function () {
      this.$router.push({
        name: "register",
      });
    },
  },
};
</script>
<style>
.imgs {
  margin: 0 15px;
}
.yimiao .inputFrom {
  margin: 15px 8%;
}
.yimiao .inputFrom input {
  width: 80%;
  margin: 8px 8%;
  padding: 8px 5px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
}
.yimiao .buttons {
  text-align: center;
}
.yimiao .buttons button {
  width: 90%;
  margin: 25px 5%;
  border-radius: 10px;
}
.buttons {
  text-align: center;
}
.buttons button {
  margin: 25px 10px;
  border-radius: 10px;
}
</style>